<template>
  <div class="form">

    <v-card>
      <v-card-title class="text-h5 grey lighten-5">
      <v-breadcrumbs :items="item">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="goToRoute(item.href)"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      </v-card-title>
  </v-card>
<v-card>
    <v-card-title class="text-h5 grey lighten-2">
      {{ $t("modultangkapandataPengesahanImbangan") }}
    </v-card-title>

   <v-container>
        <v-form ref="formPengesahanImbangan">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-bind:label="$t('hid')"
                outlined
                dense
                v-model="PengesahanImbanganhid"
                :disabled="true"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="2">
              <v-text-field
                v-bind:label="$t('ps')"
                v-model="PengesahanImbanganpusingan"
                outlined
                dense
                :disabled="true"
              ></v-text-field>
            </v-col>

            <!-- <v-col cols="12" sm="2">
              <v-btn 
                class="ml-4" 
                color="light-blue white--text" 
                @click="dialogPengesahan=true"
              >
                <span class="material-icons">add</span>{{$t('Pengesahan')}}
              </v-btn>
            </v-col> -->

            <!-- <v-col>
              <v-btn 
                v-if="userData.role !== 'RESPONDENT'"
                class="ml-4" 
                color="light-blue white--text" 
                @click="showBorangPengesahan=true"
                :disabled="statusHID != 1"
              >
                <span class="material-icons">add</span>{{$t('Pengesahan')}}
              </v-btn>
            </v-col> -->
          </v-row>

    <!-- DATATABLE  -->
    <v-card>
      <v-card-title >
        Senarai
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataPengesahanImbangan"
        :search="search"
        class="ml-3 mr-3"
        @click:row="handleClick"
        :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
      ></v-data-table>
    </v-card>

    <v-card>
      <!-- <v-card-title> <strong>HELAIAN IMBANGAN </strong><br /> </v-card-title> -->
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <strong>PENDAPATAN DAN PENERIMAAN LAIN ISI RUMAH</strong>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              Pendapatan Kasar sebulan <strong>[INCS 07/12]</strong><br
              /></v-col>

            <v-col cols="1"></v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="INCS07P12"
                label="RM"
                min="0"
                type="number"
                disabled
                @keypress="isNumber($event)"
              ></v-text-field
              
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              Penerimaan lain sebulan <strong>[INCS 09]</strong><br
            /></v-col>
            <v-col cols="1"></v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="TOTINCS09"
                label="RM"
                disabled
                min="0"
                type="number"
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              Jumlah <strong>[B]</strong><br
            /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JUMLAH_B"
                label="RM"
                min="0"
                type="number"
                @keypress="isNumber($event)"
                disabled
              ></v-text-field></v-col
          ></v-row>

          <v-row>
            <v-col>
              <strong> IMBANGAN</strong>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              Jumlah Perbelanjaan dan Pembayaran Lain Isi Rumah
              <strong>[A]</strong> <br
            /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="TOT_A"
                label="RM"
                min="0"
                type="number"
                disabled
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>
          <v-row>
            <v-col cols="20" sm="3" md="5">
              Jumlah Pendapatan dan Penerimaan Lain Isi Rumah
              <strong>[B]</strong><br
            /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="TOT_B"
                label="RM"
                min="0"
                type="number"
                disabled
                @keypress="isNumber($event)"
              ></v-text-field></v-col
          ></v-row>
          <v-row>
            <v-col cols="20" sm="3" md="5">
              Imbangan (%) <strong>[C]</strong> = <strong>[A]</strong> /
              <strong>[B]</strong> X 100%
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>
                  * Sekiranya [C] adalah kurang daripada 90% atau lebih daripada
                  110%, responden perlu menyemak semula pendapatan dan
                  perbelanjaan
                </span>
              </v-tooltip>
              <br /> </v-col
            ><br />
            <v-col cols="1"> </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="TOT_C"
                label="%"
                min="0"
                maxlength="3"
                @keypress="isNumber($event)"
                disabled
              ></v-text-field></v-col
          ></v-row>
          <v-row>
            <v-col cols="20" sm="4" md="5"> Catatan <br /></v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="5">
              <v-textarea
                outlined
                dense
                v-model="CATATAN"
                label=""
                auto-grow
                rows="3"
                row-height="25"
                shaped
              ></v-textarea
            ></v-col>
          </v-row>

           <v-row>
            <v-col cols="2">
            </v-col>
          </v-row>

          
        </v-form>
      </v-card-text>

     <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn text color="warning" @click="goToValidate()" class="mr-2">Validasi </v-btn> -->
        <v-btn text color="primary" @click="simpan()">Pengesahan </v-btn>
        <!-- <v-btn text color="primary" @click="goBack()"> Kembali </v-btn> -->
      </v-card-actions>
    </v-card>

    <v-alert prominent type="error" :value="popUpALert">
      <v-row align="center" class="mb-2">
        <v-col class="grow"> Adakah anda pasti untuk padam? </v-col>
        <v-col class="shrink">
          <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
          <v-btn @click="padam('2')">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" height="200">
      <v-card>
        <v-alert dense outlined color="#C51162" type="error">
          <strong>{{ errMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>
    </v-form>
      </v-container>
      </v-card>
  </div>
</template>
<script>
import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import axios from "../../plugins/axios";
import i18n from "@/i18n";

//////////////////////////import services///////////////////
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import lookupField from "@/services/lookupField";
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
  Name: "PengesahanImbangan",
  async beforeMount() {
  //   var dataHID = localStorageData.getHIDdata();

  //   this.HID = dataHID.HID;
  //   this.BNO = dataHID.BNO;
  //   this.Ps = dataHID.P;
  //   this.S = dataHID.S;
  //   this.NG = dataHID.NG;
  //   this.DP = dataHID.DP;
  //   this.DB = dataHID.DB;
  //   this.BP = dataHID.BP;
  //   this.ST = dataHID.ST;
  //   this.NOTK = dataHID.NOTK;
  //   this.NOIR = dataHID.NOIR;
  //   this.Bulan = dataHID.BULAN;
  //   this.Tahun = dataHID.TAHUN;

  //   this.currNOAIRData = localStorageData.getCurrentNOAIRData(); //dapatkan NOAIR yang di click dari page depan
  //   this.NOAIR = this.currNOAIRData.NOAIR;

  //   this.getINCS09()
  //   this.getTOTAL_A();
  //   this.getINCS07P12();
    this.getData(); //dapatkan data based on HID

    },

  data: () => ({
    PengesahanImbanganhid:"",
    PengesahanImbanganpusingan:"",
    updateButton: true,
    saveButton: false,
    dialog: false,
    successDialog: false,
    errorDialog: false,
    successMessage: "",
    errMessage: "",
    disabledInput: false,
    message: "Saving Data",
    popUpALert: false,
    search: "",
    currNOAIRData: "",
    butangSimpan: true,
    butangKemaskini: false,
    // dialogPengesahan: false,
    
    /////////////////////data declaration//////////////////////////
    NOAIR: "",
    HID: "",
    //INCS03:"",
    INCS01:"",
    INCS02:"",
    TP73:"",
    INCS05:"",
    INCS06:"",
    INCS07:"",
    INCS08:"",
    INCS10:"",
    TOTINCS09: "",
    INCS07P12: "",
    TOT_A: "",
    TOT_B: "",
    CATATAN: "",
    dataPengesahanImbangan: [],
    rules: [(value) => !!value || "Required."],
    headers: [
      {
        //text: "NOAIR",
        align: "start",
        sortable: false,
        //value: "NOAIR",
      },

      { text: "HID", value: "HID" },
      { text: "Pendapatan Kasar Sebulan", value: "INCS07P12" },
      { text: "Penerimaan Lain Sebulan", value: "TOTINCS09" },
      { text: "Jumlah [B]", value: "JUMLAH_B" },
      { text: "Imbangan [A]", value: "TOT_A" },
      { text: "Imbangan [B]", value: "TOT_B" },
      { text: "Imbangan [%]", value: "TOT_C" },
      { text: "Catatan", value: "CATATAN" },
    ],

    ///////////link untuk ke page/////////////////////
    item: [
      {
        text: "Paparan Utama",
        disabled: false,
        href: "paparanutama",
      },
      {
        text: "BLOK 3 (PreCode)",
        disabled: false,
        href: "BLK3PreCode",
      },
      {
        text: "BLOK 3",
        disabled: false,
        href: "blk3",
      },
      {
        text: "BLOK 4a",
        disabled: false,
        href: "Blok4a",
      },
      {
        text: "BLOK 4b",
        disabled: false,
        href: "Blok4b",
      },
      {
        text: "BLOK 4c",
        disabled: false,
        href: "Blok4c",
      },
      {
        text: "BLOK 7",
        disabled: false,
        href: "blk7",
      },
      {
        text: "BLOK 7 (Imbangan)",
        disabled: false,
        href: "Blok7Imbangan",
      },
      {
        text: "Pengesahan (Imbangan)",
        disabled: true,
        href: "PengesahanImbangan",
      },
    ],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
  }),
  mounted() {
    this.paparanpermulaan();
    // this.tambahcatatan = "-";
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}/${this.$route.params.hid}`;
    },
    getUnits: function (a) {
      alert(`${a}`);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
   
    kiraJUMLAH_B() {
      var total = 0;
      total = Number(this.INCS07P12) + Number(this.TOTINCS09);
      this.JUMLAH_B = total;
    },
    kiraTOT_C() {
      var total = 0;
      total = (Number(this.TOT_A) / Number(this.TOT_B)) * 100;
      this.TOT_C = total;
    },

    // kiraINCS06(data){ 
    //   var total = 0
    //      total = Number(total) + (Number(data.INCS41) + Number(data.INCS42)+ Number(data.INCS43) + Number(data.INCS44) + Number(data.INCS45) + Number(data.INCS46)) - Number(data.TP73)
    //     return total;
    // },
    
     async paparanpermulaan() {
      try {
        if (typeof this.$route.params.hid !== "undefined") {
          await axios
            .get(
              `${process.env.VUE_APP_API_URL}/auth/decode?de=${this.$route.params.hid}`
            )
            .then((result) => {
              this.PengesahanImbanganhid = result.data.decode;
              this.HID = this.PengesahanImbanganhid;
              const jr2 = {
                hidjr2: this.PengesahanImbanganhid,
              };
              axios
                .post(`${process.env.VUE_APP_API_URL}/JR/papardatajr2`, jr2)
                .then((res) => {
                this.PengesahanImbanganhid = res.data.data.HID;
                this.HID = this.PengesahanImbanganhid;
                 this.PengesahanImbanganpusingan = res.data.data.P;
                });
            });

            this.getINCS09()
            this.getTOTAL_A();
            //this.getINCS03();
            this.getINCS07P12();
            this.getData(); //dapatkan data based on HID
        } else {
          this.$router.push(`/${i18n.locale}/heshid`, () => {});
        }
      } catch (err) {
        console.log(err);
        if (err.response.data.msg === "errordecode") {
          this.$router.push(`/${i18n.locale}/heshid`, () => {});
        }
      }
    },

    async simpan(){

           try{
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/pengesahan/updateHID`, {

                HID:  this.HID,
                NOAIR: this.NOAIR,
                totalINCS21NA : this.INCS21NA,
                totalINCS21 : this.INCS21,
                totalINCS01 : this.INCS01,
                totalINCS02 : this.INCS02,
                totalINCS03 : this.INCS03,
                totalINCS05 : this.INCS05,
                totalINCS06 : this.INCS06,
                totalINCS07 : this.INCS07,
                totalINCS08 : this.INCS08,
                totalINCS10 : this.INCS10,
                totalTP73 : this.TP73,
                Sample: this.S,
                TOTINCS09: this.TOTINCS09,
                INCS07P12: this.INCS07P12,
                JUMLAH_B: this.JUMLAH_B,
                TOT_A: this.TOT_A,
                TOT_B: this.TOT_B,
                TOT_C: this.TOT_C,
                CATATAN: this.CATATAN,
                statusHID: 3

              })
                
                this.successMessage = 'Pengesahan selesai! ke modul validasi';
                this.successDialog = true;
                // this.reset();
                this.getData();
                setTimeout(() => (this.successDialog = false, this.goToValidate() ), 2000);
                window.scrollTo(0, 0);
                
            } catch (error) {
              console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error; 

            }

    },


    async padam(val) {
      if (val == 0) {
        this.popUpALert = true;
      } else if (val == 1) {
        try {
          ///////////tunjukkan alert padam////////////
          this.popUpALert = false;
          ////send delete to API///////
          if (this.$refs.form.validate()) {
            const res = await axios.post(
              `${process.env.VUE_APP_API_URL}/blk/PengesahanImbangan`,
              {
                HID: this.HID,
                NOAIR: this.NOAIR,
              }
            );
            this.res = res.data;
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Deleted!";
            this.saveButton = false;
            this.updateButton = true;
            this.reset();
            this.getData();
          } else {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = "Please Fill In the field";
          }
        } catch (error) {
          console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Padam : " + error;
        }
      } else if (val == 2) {
        this.popUpALert = false;
      }
    },

    async getINCS09(){
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/getINCS09?HID=`+this.PengesahanImbanganhid, {

            })
            var dataz = res.data.data;
            // console.log(dataz);
            var total = 0;
            for(var i = 0;i<dataz.length;i++){
              total = total + Number(dataz[i].INCS09);
            }
            this.TOTINCS09 = total;
            //console.log(this.TOTINCS09)
          } catch (error) {
            console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },

    async getTOTAL_A() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getTOTAL_A?HID=` + this.HID,{}
        );
        var dataz = res.data.data;
        // console.log(dataz);
        // this.TOT_A = dataz;

        var total = 0;
        for (var i = 0; i < dataz.length; i++) {
          total = total + Number(dataz[i].RMNEG);
        }
        //this.TOT_A = total;

        this.totalTOT_A = total;
        let numB = this.totalTOT_A;
        this.TOT_A = numB.toFixed(2);

        
      } catch (error) {
        console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

    async getINCS07P12() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getINCS07P12?HID=` +this.PengesahanImbanganhid ,{});
        var dataz = res.data.data;



        //  console.log(dataz);
          var total = 0;
          var INCS21NA = 0;
          var INCS21 = 0;
          var INCS22 = 0;
          var INCS23 = 0;
          var INCS24 = 0;
          var INCS01 = 0;
          var INCS02 = 0;
          var INCS31 = 0;
          var INCS32 = 0;
          var INCS34 = 0;
          var INCS33 = 0;
          var INCS03 = 0;
          var INCS05 = 0;
          var INCS06 = 0;
          var INCS07 = 0;
          var INCS08 = 0;
          var INCS10 = 0;
          var TP73 = 0;

          for(var i = 0;i<dataz.length;i++){
            if(dataz[i].INCS01 == null){
              dataz[i].INCS01 = 0;
            }
           if(dataz[i].HK4INCS21b == null){
              dataz[i].HK4INCS21b = 0;
            }
            if(dataz[i].HK4INCS21b == null){
              dataz[i].HK4INCS21b = 0;
            }
            if(dataz[i].HK4INCS21c == null){
              dataz[i].HK4INCS21c = 0;
            }
            if(dataz[i].HK5INCS21d == null){
              dataz[i].HK5INCS21d = 0;
            }
            if(dataz[i].HK6INCS21e == null){
              dataz[i].HK6INCS21e = 0;
            }
            if(dataz[i].HK2INCS21a == null){
              dataz[i].HK2INCS21a = 0;
            }
            if(dataz[i].HK3INCS21a == null){
              dataz[i].HK3INCS21a = 0;
            }
            if(dataz[i].INCS21KS == null){
              dataz[i].INCS21KS = 0;
            }
            if(dataz[i].INCS22 == null){
              dataz[i].INCS22 = 0;
            }
            if(dataz[i].INCS23 == null){
              dataz[i].INCS23 = 0;
            }
            if(dataz[i].INCS24 == null){
              dataz[i].INCS24 = 0;
            }
            if(dataz[i].INCS31 == null){
              dataz[i].INCS31 = 0;
            }
            if(dataz[i].INCS32a == null){
              dataz[i].INCS32a = 0;
            }
            if(dataz[i].INCS32b == null){
              dataz[i].INCS32b = 0;
            }
            if(dataz[i].INCS33 == null){
              dataz[i].INCS33 = 0;
            }
            if(dataz[i].INCS34 == null){
              dataz[i].INCS34 = 0;
            }
            if(dataz[i].INCS05 == null){
              dataz[i].INCS05 = 0;
            }
             if(dataz[i].INCS02 == null){
              dataz[i].INCS02 = 0;
            }
            // if(dataz[i].TP73A == null){
            //   dataz[i].TP73A = 0;
            // }
            // if(dataz[i].TP73B == null){
            //   dataz[i].TP73B = 0;
            // }
                 INCS21NA = Number(INCS21NA) + Number(dataz[i].HK4INCS21b) + Number(dataz[i].HK4INCS21c) + Number(dataz[i].HK5INCS21d) + Number(dataz[i].HK6INCS21e);
                 INCS01 = Number(INCS01) + Number(dataz[i].INCS01)
                 INCS21 = Number(INCS21) + Number(dataz[i].HK2INCS21a) + Number(dataz[i].HK3INCS21a) + Number(dataz[i].HK4INCS21b) + 
                          Number(dataz[i].HK4INCS21c) + Number(dataz[i].HK5INCS21d) + Number(dataz[i].HK6INCS21e) + 
                          Number(dataz[i].INCS21KS);
                 INCS22 = Number(INCS22)+ Number(dataz[i].INCS22);
                 INCS24 = Number(INCS24)+ Number(dataz[i].INCS24);
                 INCS23 = Number(INCS23)+ Number(dataz[i].INCS23);
                //  INCS02 = Number(INCS02) + Number(dataz[i].HK2INCS21a) + Number(dataz[i].HK3INCS21a) + Number(dataz[i].HK4INCS21b) + 
                //           Number(dataz[i].HK4INCS21c) + Number(dataz[i].HK5INCS21d) + Number(dataz[i].HK6INCS21e) + 
                //           Number(dataz[i].INCS21KS) + Number(dataz[i].INCS22) + Number(dataz[i].INCS23) + Number(dataz[i].INCS24);
                 INCS32 = Number(INCS32)+ (Number(dataz[i].INCS32a) + Number(dataz[i].INCS32b)); 
                 INCS31 = Number(INCS31)+ Number(dataz[i].INCS31);
                 INCS33 = Number(INCS33)+ Number(dataz[i].INCS33);
                 INCS34 = Number(INCS34)+ Number(dataz[i].INCS34);
                // INCS03 = Number(INCS03) + Number(dataz[i].INCS31) + (Number(dataz[i].INCS32a) + Number(dataz[i].INCS32b)) + Number(dataz[i].INCS33) + Number(dataz[i].INCS34);
                 INCS05 = Number(INCS05) + Number(dataz[i].INCS41) + Number(dataz[i].INCS42)+ Number(dataz[i].INCS43) + Number(dataz[i].INCS44) + Number(dataz[i].INCS45) + Number(dataz[i].INCS46);
                 TP73 = Number(TP73) + Number(dataz[i].TP73)
                 INCS10 = Number(INCS10) + Number(dataz[i].INCS10)

                
                 //INCS06 = Number(INCS06) + (Number(INCS05) - Number(TP73));
                 
                //  INCS07 = Number(INCS07) + Number(dataz[i].INCS01) + Number(dataz[i].HK2INCS21a) + Number(dataz[i].HK3INCS21a) + 
                //           Number(dataz[i].HK4INCS21b) + Number(dataz[i].HK4INCS21c) + Number(dataz[i].HK5INCS21d) + 
                //           Number(dataz[i].HK6INCS21e) + Number(dataz[i].INCS21KS) + Number(dataz[i].INCS22) + 
                //           Number(dataz[i].INCS23) + Number(dataz[i].INCS24) + Number(dataz[i].INCS31) + (Number(dataz[i].INCS32a) + 
                //           Number(dataz[i].INCS32b)) + Number(dataz[i].INCS33) + Number(dataz[i].INCS34) + Number(dataz[i].INCS41) + 
                //           Number(dataz[i].INCS42)+ Number(dataz[i].INCS43) + Number(dataz[i].INCS44) + Number(dataz[i].INCS45) + 
                //           Number(dataz[i].INCS46);
                //  INCS08 = Number(INCS08) + Number(dataz[i].INCS01) + Number(dataz[i].HK2INCS21a) + Number(dataz[i].HK3INCS21a) + 
                //           Number(dataz[i].HK4INCS21b) + Number(dataz[i].HK4INCS21c) + Number(dataz[i].HK5INCS21d) + 
                //           Number(dataz[i].HK6INCS21e) + Number(dataz[i].INCS21KS) + Number(dataz[i].INCS22) + 
                //           Number(dataz[i].INCS23) + Number(dataz[i].INCS24) + Number(dataz[i].INCS31) + (Number(dataz[i].INCS32a) + 
                //           Number(dataz[i].INCS32b)) + Number(dataz[i].INCS33) + Number(dataz[i].INCS34) + (INCS05 - Number(dataz[i].TP73));
                 

                 // console.log(INCS08)
                      // console.log("TP73A: "+Number(dataz[i].TP73A))
                //console.log("INCS07: "+INCS07)
                // console.log("INCS06: "+INCS06)
                //  console.log("INCS31: "+Number(dataz[i].INCS31))
                //  console.log("INCS32: "+Number(dataz[i].INCS32))
                //  console.log("INCS33: "+Number(dataz[i].INCS33))
                //  console.log("INCS34: "+Number(dataz[i].INCS34))
                //console.log("INCS03: "+INCS03)

                //  MAI & ISMA ps JANGAN BUANG CONSOLE.LOG NI

                //  console.log("INCS01: "+Number(dataz[i].INCS01))
                //console.log("INCS02: "+INCS02)
                //  console.log("INCS03: "+INCS03)
                //  console.log("INCS05: "+Number(dataz[i].INCS05))
                //  console.log("INCS06: "+INCS06)
                //  console.log("INCS07: "+INCS07)
                //  console.log("INCS08: "+INCS08)
          }
         
        this.INCS21NA = INCS21NA;
        this.INCS21 = INCS21;
        this.INCS01 = INCS01;
        this.INCS02 = Number(INCS21) + Number(INCS22) + Number(INCS23) + Number(INCS24);
        //this.INCS02 = Number(INCS02);
        this.INCS03 = Number(INCS31) + Number(INCS32) + Number(INCS33) + Number(INCS34);
        this.INCS05 = INCS05;
        this.INCS06 = Number(INCS05) - Number(TP73);
        this.INCS07 = Number(this.INCS01) + Number(this.INCS02) + Number(this.INCS03) + Number(this.INCS05);
        this.INCS08 = Number(this.INCS01) + Number(this.INCS02) + Number(this.INCS03) + Number(this.INCS06);
        this.INCS10 = INCS10;
        this.TP73 = TP73;

        // console.log("INCS05: "+INCS05)
        // console.log("INCS06: "+INCS06)
        // console.log("TP73: "+TP73)
      
        let numB = Number(this.INCS07/12); 
        this.INCS07P12 = numB.toFixed(2);
        console.log("INCS07: "+this.INCS07)
        console.log("INCS07P12: "+this.INCS07P12)
        console.log("INCS09: "+this.TOTINCS09)
        
      } catch (error) {
        console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },


    async getData() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/blk/PengesahanImbangan?HID=` +this.PengesahanImbanganhid+`&NOAIR=01`,{}
        );
        var dataz = res.data.data;
        this.dataPengesahanImbangan = dataz;
      } catch (error) {
        console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

    handleClick(row) {
      this.saveButton = true;
      this.updateButton = false;
      this.successDialog = true;
      this.successMessage = "Sila mulakan pengemaskinian!";
      setTimeout(() => (this.successDialog = false), 1000);

      this.butangSimpan = false;
      this.butangKemaskini = true;
      
      this.HID = row.HID;
      this.NOAIR = row.NOAIR;
      this.INCS07P12 = row.INCS07P12;
      this.TOTINCS09 = row.TOTINCS09;
      this.JUMLAH_B = row.JUMLAH_B;
      this.TOT_A = row.TOT_A;
      this.TOT_B = row.TOT_B;
      this.TOT_C = row.TOT_C;
      this.CATATAN = row.CATATAN;

      // or just do something with your current clicked row item data
      console.log(row);
    },

    goTo() {
      this.$router.push({ name: "PengesahanImbangan" });
    },
    goToValidate(){
      // Sending data
      //this.$router.push({ path: '/validasi', params: { noHID: this.PengesahanImbanganhid } });
      // this.$router.push({ name: `/validasi/${this.PengesahanImbanganhid}` });
      this.$router.push({ 
        name: "validasi",
        params: {
            noHID: this.PengesahanImbanganhid
        } 
      });
    },
    goBack() {
      this.$router.push({ name: "Blok7Imbangan" });
    },

    isNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  watch: {
    INCS09(val) {
      this.TOTINCS09 = Number(this.INCS09);
    },

    JUMLAH_B(val) {
      this.TOT_B = Number(this.JUMLAH_B);
    },
  },
  computed: {
    INCS09: function () {
      var total = 0;
      total =
        Number(this.JUM9a) +
        Number(this.JUM9b) +
        Number(this.JUM9c) +
        Number(this.JUM9d) +
        Number(this.JUM9e);

      return total;
    },

    JUMLAH_B: function () {
      var total = 0;
      total = Number(this.INCS07P12) + Number(this.TOTINCS09);
      return total;
    },
    TOT_C: function () {
      var total = 0;
      total = (Number(this.TOT_A) / Number(this.TOT_B)) * 100;
      // this.totalTOT_C = total;
      
      // let numC = this.totalTOT_C;
      // this.TOT_C = numC.toFixed(2);
     

      return total.toFixed(2);
    },

     computedINCS06: function(){

                  var total = 0;
                  // for(var i=0;i<this.summaryData.dataJR5.length;i++){
                 // total = Number(total) + (Number(this.INCS41) + Number(this.INCS42)+ Number(this.INCS43) + Number(this.INCS44) + Number(data.INCS45) + Number(data.INCS46)) - Number(data.TP73)
                  total = Number(total) + Number(this.INCS05) - Number(this.TP73) 
                  // total = Number(total) + Number(this.totalINCS05) + Number(this.totalHK4INCS21c) + Number(this.totalHK5INCS21d) + Number(this.totalHK6INCS21e) 
                  // total = Number(total) + Number(this.summaryData.dataJR5[i].INCS06)
                //}
                return total;
              },
  },
};
</script>



